module.exports = __webpack_public_path__ + "img/9791187206385.a7fe4ae3.jpg";